export default "__VITE_ASSET__DOAau4DB__"